'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = list;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function list(event) {
  var date = (0, _moment2.default)(event.start_date);
  var query = {
    date: (0, _moment2.default)(event.start_date).format('YYYY-MM-DD_HH-mm-ss')
  };
  var itemAttributes = { className: 'EventListItem list' };
  var formattedDate = date.format('HH[h]mm');

  return _react2.default.createElement(
    'article',
    itemAttributes,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: { pathname: '/evenements/' + event.slug + '/' + event.id, query: query } },
      _react2.default.createElement('img', { alt: event.title, src: event.display_image_url || '/images/logo-uqam.png' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'content' },
      _react2.default.createElement(
        'div',
        { className: 'info' },
        _react2.default.createElement(
          'time',
          { dateTime: date.format('YYYY-MM-DDTHH:mm') },
          formattedDate
        ),
        event.venue && _react2.default.createElement(
          'p',
          { className: 'venue' },
          event.venue.name
        )
      ),
      _react2.default.createElement(
        'h1',
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { to: { pathname: '/evenements/' + event.slug + '/' + event.id, query: query } },
          event.title
        )
      ),
      event.types && _react2.default.createElement(
        'ul',
        { className: 'types' },
        event.types.map(function (type) {
          return _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: { pathname: '/evenements', query: { types: type.id } } },
              _react2.default.createElement(_caligramReact.SelectableLabel, { appearance: 'tag', label: type.name })
            )
          );
        })
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/templates/list.js
// module id = 1153
// module chunks = 0